// DeleteConfirmation.js
import React from 'react';
import styles from "../../TemplateManagement.module.css"
import { LFade, LDialog, LButton } from "@loffa/gpp-modules";

const ConfirmationModal = ({ isOpen, title, subtitle, message, confirmLabel = "Confirm", cancelLabel = "Cancel", onConfirm, onClose}) => {
  if (!isOpen) return null;
  const actions = (
    <>
      <LButton onClick={onClose}>
        {cancelLabel}
      </LButton>
      <LButton onClick={onConfirm} themeColor="primary">
        {confirmLabel}
      </LButton>
    </>
  );

  return (
    <LFade transitionEnterDuration={300}>
      <LDialog
        width="700"
        title={title}
        subtitle={subtitle}
        body={<div className={styles.templateManagerModalBody}>{message}</div>}
        action={actions}
        actionCloseButton={onClose}
        actionOverlay={onClose}
      />
    </LFade>
  );
};

export { ConfirmationModal };